













import { Component, Vue } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue';
import XeroAuthCallback from '@/components/Integrations/XeroAuthCallback.vue';

@Component({
  name: 'XeroAuthCallbackView',
  components: { Alert, XeroAuthCallback }
})
export default class extends Vue {}
